import { createModelSelector } from '@ngxs/store';
import { EmailTemplatesSelectors } from '@state/email-templates/email-templates.selectors';
import { UserProfileState } from '@state/user-profile';

export const $emailTemplatesViewModel = createModelSelector({
	emailTemplates: EmailTemplatesSelectors.$emailTemplates,
	selectedTemplate: EmailTemplatesSelectors.$selectedEmailTemplate,
	currentUserId: UserProfileState.getProfileId,
	canEditCloserEmailTemplates: UserProfileState.$canEditCloserEmailTemplates,
});
